import React from 'react';

interface SettingsCardProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  description,
  icon,
  children,
  className = ''
}) => {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-3xl border-2 border-gray-200 dark:border-gray-700 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-primary/30 ${className}`}>
      {/* Accent bar */}
      <div className="h-[3px] bg-primary" />

      <div className="p-6 sm:p-8">
        {/* Header */}
        <div className="flex items-center mb-6">
          {icon && (
            <div className="mr-3 bg-primary/10 dark:bg-primary/20 rounded-2xl p-2.5 text-primary" aria-hidden="true">
              {icon}
            </div>
          )}
          <div>
            <h2 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
              {title}
            </h2>
            {description && (
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                {description}
              </p>
            )}
          </div>
        </div>

        {/* Content */}
        <div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default SettingsCard;